import React, { useEffect, useState, useCallback } from 'react';
import "./portfolioCompanies.css";
import "../../common/css/layout.css";
import PortcoForm from "./PortcoForm";
import PortcoTable from "./PortcoTable";
import PortcoChart from "../dashboard/PortcoChart";
import { fetchPortcos, fetchFundsWithInvestments } from '../../common/helpers/PortfolioCompaniesHelper';


const PortfolioCompanies = () => {
  const [data, setData] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [editData, setEditData] = useState(null);

  const fetchAllData = useCallback(async () => {
    const [portcos, chartData] = await Promise.all([fetchPortcos(), fetchFundsWithInvestments()]);
    if (portcos) {
        setData(portcos);
    }
    if (chartData) {
        setChartData(chartData);
    }
}, [fetchPortcos, fetchFundsWithInvestments]); // Include any dependencies for fetchAllData in this array.

useEffect(() => {
    fetchAllData();
}, [fetchAllData]);



const handleEdit = (portco) => {
  setEditData({
      portcoId: portco.portco_id,
      legalName: portco.company_legal_name,
      companyName: portco.company_name,
      pitchbookId: portco.pitchbook_id,
      websiteUrl: portco.website_url,
      websiteBlurb: portco.website_blurb,
      showOnWebsite: portco.show_on_public_website
  });
};

const handleClear = () => {
  setEditData(null);
};

  const handleSubmit = () => {
    setEditData(null); // Clear the form after submitting
    fetchAllData(); // Refetch the data to update the table and chart
  };
  

  return (
    <div className="all-components-container">
    <div className="component component-in-row-2">
        <div className="component-heading">
            Manage Portfolio Companies
        </div>
        <PortcoForm onSubmit={handleSubmit} editData={editData} onClear={handleClear}/>
    </div>
    <div className="component-no-border component-in-row-2">
        <div className="component-heading">
            <h2>Portfolio Companies Overview</h2>
        </div>
        {chartData && <PortcoChart data={chartData} />}
    </div>
    <div className="component-no-border component-in-row-1">
        {data && <PortcoTable data={data} onEdit={handleEdit} onDelete={fetchAllData}/>}
    </div>
</div>

  )
}

export default PortfolioCompanies;
